<!-- =========================================================================================
  File Name: ListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
     <vs-alert :active="userEmail" icon-pack="feather" icon="icon-alert-octagon"  color="danger" class="mb-2">
    Your email is not verified. You will not be able to receive email alerts. <span class="cursor-pointer text-primary" @click="emailPopup=true">Click here </span>to verify your email
</vs-alert>
<vs-alert :active="userPhone" icon-pack="feather" icon="icon-alert-octagon"  color="danger" class="mb-2">
    Your phone number can't receive SMS messages. You will not be able to receive SMS alerts.<span class="cursor-pointer text-primary"  @click="phonePopup=true"> Click here</span> to verify your phone number.
</vs-alert>                
    <vs-popup class="holamundo"  title="Enter Email" :active.sync="emailPopup">
  <vs-row v-if="EmailShow">        
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
    <vs-input class="w-full" v-model="dataEmail" placeholder="Enter Email" name="email" v-validate="'email|required'" maxlength="100"></vs-input><br>
     <!-- <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span> -->

    </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
         <vs-button color="success" :disabled="!isEmailValid" @click.native="SaveEmail">Send Email</vs-button>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
     <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>

    </vs-col>
</vs-row>
  <vs-row v-if="!EmailShow">        
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
    <vs-input class="w-full" v-model="dataEmailCode" placeholder="Enter Code"></vs-input>
    </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
         <vs-button color="success" @click.native="VerifyEmail">Verify</vs-button>
    </vs-col>
</vs-row>
    </vs-popup>
        <vs-popup class="holamundo"  title="Enter Phone" :active.sync="phonePopup">
        <vs-row v-if="PhoneShow">        
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
    <vs-input class="w-full" v-model="dataPhone" @input="acceptNumber" placeholder="Enter Phone"></vs-input>
    </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
         <vs-button color="success" :disabled="!isPhoneValid"  @click.native="SavePhone">Send SMS</vs-button>
    </vs-col>
</vs-row>
  <vs-row v-if="!PhoneShow">        
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
    <vs-input class="w-full" v-model="dataSmsCode" placeholder="Enter Code"></vs-input>
    </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
         <vs-button color="success" @click.native="VerifySms">Verify</vs-button>
    </vs-col>
</vs-row>
    </vs-popup>
    <!-- <vs-table ref="table"  :data="filteredStudentList" :max-items="itemsPerPage"  pagination
              search>
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

        </div> -->

        <!-- ITEMS PER PAGE -->
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ students.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : students.length }} of {{ queriedStudents }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div> -->
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <!-- <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead" >
        <vs-th sort-key="name">Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="popularity">Camera(s)</vs-th>
      </template>

      <template slot-scope="{data}" >
        <tbody >
        <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td class="img-container">
            <img v-if="tr.image" :src="img_cdn+tr.image" class="rounded-full shadow-md studentdot mr-2"/>
            <p v-else class="bg-primary studentdot text-white mr-2" :data-letterstudent="tr.fname[0].toUpperCase()"></p>
          </vs-td>
          <vs-td>
            <p v-if="lng === 'dogs'" class="product-name font-medium truncate flex">{{tr.fname}}</p>
            <p v-else class="product-name font-medium truncate">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</p>
            <span class="flex items-center" @click="MessagePopupAction(tr)">
                  <feather-icon icon="MessageCircleIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Message</span>
                </span>
          </vs-td>
          <vs-td>
            <vx-tooltip style="display: inline-block" v-for="item in tr.cameras" :key="item.id" :text="item.name"
                        position="top">
              <router-link :to="{ path: '/students/cameras/'+ encrptId + item.id + encrptId}"
                           class="text-inherit underline"><p :style="{background: item.color_code}"
                                                             class="w-4 h-4 round" style="float: left"></p>
              </router-link>
            </vx-tooltip>

          </vs-td>
            </vs-tr>
        </tbody>
      </template>
    </vs-table> -->
    <div id="demo-basic-card" v-if="studentLength > 0">
        <div class="vx-row">
              <div class="vx-col w-full sm:w-1/3 lg:w-1/6 mb-base" :key="indextr" v-for="(tr, indextr) in filteredStudentList">
                <vx-card class="p-0">
                    <vs-avatar class="mx-auto mb-6 block coverimg" size="80px" v-if="tr.image" :src="img_cdn+tr.image" />
                    <p v-else class="bg-primary letteruserstudent text-white mx-auto mb-6 block mt-2"  :data-letteruserstudent="tr.fname[0].toUpperCase()"></p>
                    <div class="text-center" style="word-wrap: break-word">
                      <h4  v-if="lng === 'dogs'">{{tr.fname}} </h4>
                      <h4 v-else>{{tr.fname}} {{tr.lname}}</h4>
                      <p class="text-grey" @click="MessagePopupAction(tr.id)" style="cursor:pointer"><feather-icon icon="MessageCircleIcon"  svgClasses="h-4 w-4"/>Messages</p>
                    </div>
                     <!-- <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap">
                      <vs-row>
                        <vs-col  vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
                            <span>
                            <p class="text-xl">Cameras</p>
                            <p v-if="tr.cameras.length === 0" class="text-grey">No camera</p>
                            <vx-tooltip v-else style="display: inline-block" v-for="item in tr.cameras" :key="item.id" :text="item.name" position="top">
                              <router-link :to="{ path: '/students/cameras/'+ encrptId + item.id + encrptId}" class="text-inherit underline"><p :style="{background: item.color_code}" class="w-4 h-4 round" style="float: left"></p></router-link>
                             </vx-tooltip>
                           </span>
                         </vs-col>
                       </vs-row>
                    </div> -->
                </vx-card>
            </div>
        </div>
    </div>
    <div v-else>No Student Found.</div>
    <div class="demo-alignment">
      <div class="fill-row-loading">
        <div
          :class="{ activeLoading: activeLoading }"
          :id="[`loading-sound`]"
          class="vs-con-loading__container loading-example"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {
  GET_USER_STUDENTS,
  UPDATE_STUDENT_STATUS,
  SEND_VERIFY_USER_EMAIL,
  MATCH_VERIFY_USER_EMAIL_CODE,
  SEND_VERIFY_USER_SMS ,
  MATCH_VERIFY_USER_SMS_CODE
} from '@/graphql'

export default {
  components: {
    moment
  },
  data () {
    return {
      encrptId: '',
      students: [],
      selected: [],
      cameras: [],
      locations: [],
      itemsPerPage: 4,
      isMounted: false,
      meID: '',
      meRole: '',
      lng:'',
      types: ['sound'],
      encrptId : '',
      students:[],
      selected:[],
      cameras:[],
      locations:[],
      itemsPerPage: 4,
      isMounted: false,
      meID:'',
      meRole:'',
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      types:['sound'],
      popupActive: false,
      activeLoading: false,
      custom_search_filter: 'Search By Location',
      custom_search_filter_camera: 'Search By Camera',
      // products: [],

      // Data Sidebar
      addNewDataSidebar: false,
      addNewCamUserSidebar: false,
      addSettingSidebar: false,
      addPasswordSidebar: false,
      addScheduleSidebar: false,
      sidebarSettingData: {},
      sidebarData: {},
      camUserSidebarData: {},
      passwordSidebarData: {},
      scheduleData: {},
      Imgdlt: '',
      DeletedItem: '',
      currrent_schedule: {
        dates: {
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
          Saturday: [],
          Sunday: []
        }
      },
      dataUserSchedule: {
        schedule: {
          scheduledates: {}
        }
      },
      current_schedule_dates: '',
      ddd: '',
      MessagePopup : false,
      messageSidebar: false,
      messageData:{},
      userEmail:true,
      userPhone:true,
      emailPopup:false,
      phonePopup:false,
      dataEmail:null,
      dataPhone:null,
      EmailShow:true,
      dataEmailCode:null,
      PhoneShow:true,
      dataSmsCode:null,
      oldPhone:null,
      oldEmail:null,
    }
  },
  watch:{
       phonePopup(val){
               this.dataSmsCode=null
               this.dataPhone=this.oldPhone

       },
       emailPopup(val){
         this.dataEmail=this.oldEmail
         this.dataEmailCode=null
         this.$validator.reset()
       }
  },
  computed: {
    studentLength(){
      return this.filteredStudentList.length
    },
    isPhoneValid(){
        return (
        !this.errors.any() &&
        this.dataPhone &&
        this.dataPhone.length==14
      )
    },
    isEmailValid(){
        return (
        !this.errors.any() &&
         this.dataEmail
      )
    },
    filteredStudentList () {
      return this.students.filter(function (student) {   
        if(student.status){
          return true
        }else{
          return false
        }
       })
      // const custom_search_filter_camera = this.custom_search_filter_camera
      // const custom_search_filter = this.custom_search_filter
      // return this.students.filter(function (student) {
      //   if (
      //     custom_search_filter_camera != 'Search By Camera' &&
      //     custom_search_filter == 'Search By Location'
      //   ) {
      //     for (let i = 0; i < student.cameras.length; i++) {
      //       if (student.cameras[i].name == custom_search_filter_camera) {
      //         return true
      //       }
      //     }
      //     return false
      //   }
      //   if (custom_search_filter == 'Search By Location') {
      //     return true
      //   }
      //   if (custom_search_filter !== 'Search By Location') {
      //     return student.location.name.match(custom_search_filter)
      //   }
      //   return true
      // })
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length
    },

    locln () {
      return this.locations.length
    },
    queriedStudents () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.students.length
    },
    select () {
      return this.selected.length
    }
  },
  methods: {
    // MessagePopupAction(data){
    //   this.MessagePopup=true
    //   this.messageSidebar = !this.messageSidebar
    //   this.messageData = data
    // },
    MessagePopupAction (id) {
       this.$store.dispatch('setStudent', null)
      this.$store.dispatch('setStudent', id)
      this.$router.push('/alerts')
    },
    // getStudentSchedule(id) {
    //   let student_schedule = [];
    //   for (let i = 0; i < this.students.length; i++) {
    //     if (this.students[i].id == id) {
    //       if (this.students[i].schedule) {
    //         for (
    //           let j = 0;
    //           j < this.students[i].schedule.scheduledates.length;
    //           j++
    //         ) {
    //           student_schedule.push(this.students[i].schedule.scheduledates[j]);
    //         }
    //         this.dataUserSchedule.schedule.scheduledates = student_schedule;
    //         this.getCurrentPeriod();
    //         this.CheckCondtion1(this.currrent_schedule.dates);
    //         this.MergeCurrentSlot(this.currrent_schedule.dates);
    //         let userMergedSlots = this.MergeUserScheduleSlots(
    //           this.dataUserSchedule
    //         );
    //         ////Condition 2: check each slot
    //         let condition2 = true;
    //         let totalCurrentSlotSlots = 0;
    //         let validCurrentSlots = 0;
    //         for (let day in this.current_schedule_dates) {
    //           for (let j in this.current_schedule_dates[day]) {
    //             if (
    //               this.current_schedule_dates[day][j].start_time != "" &&
    //               this.current_schedule_dates[day][j].end_time != ""
    //             ) {
    //               totalCurrentSlotSlots++;

    //               let currentSlotStartTimeSeconds = this.current_schedule_dates[
    //                 day
    //               ][j].start_time;
    //               let currentSlotEndTimeSeconds = this.current_schedule_dates[
    //                 day
    //               ][j].end_time;

    //               for (let i in userMergedSlots[day]) {
    //                 if (
    //                   currentSlotStartTimeSeconds >=
    //                     userMergedSlots[day][i].start_time &&
    //                   currentSlotStartTimeSeconds <=
    //                     userMergedSlots[day][i].end_time
    //                 ) {
    //                   validCurrentSlots++;
    //                   break;
    //                 }
    //               }
    //             }
    //           }
    //         }
    //         // console.log( totalCurrentSlotSlots);
    //         // console.log( validCurrentSlots );
    //         // console.log(this.ddd)
    //         // condition2 = totalCurrentSlotSlots == validCurrentSlots

    //         //// End Condition 2
    //         if (
    //           totalCurrentSlotSlots == validCurrentSlots &&
    //           this.ddd.length == 0 &&
    //           totalCurrentSlotSlots + validCurrentSlots !== 0
    //         ) {
    //            //
    //         } else {
    //           var without_cam_student = [];
    //           for (let i = 0; i < this.students.length; i++) {
    //             if (this.students[i].id == id) {
    //               this.students[i].cameras = "";
    //               without_cam_student.push(this.students[i]);
    //             }
    //           }
    //           // this.students=without_cam_student
    //         }
    //       }
    //     }
    //   }
    // },
    CheckCondtion1 (scheduleDates) {
      ////Condition1: Check if child days exist in parent
      //days of parent
      const parentScheduleDays = []

      for (const i in this.dataUserSchedule.schedule.scheduledates) {
        const element = this.dataUserSchedule.schedule.scheduledates[i]

        if (element['start_time'] != '' && element['end_time'] != '') {
          if (parentScheduleDays.indexOf(element['day']) == -1) {
            parentScheduleDays.push(element['day'])
          }
        }
      }

      //days of child
      const childScheduleDays = []

      for (const i in scheduleDates) {
        const element = scheduleDates[i]

        for (const j in element) {
          // console.log( "element" );
          // console.log( element[j] );

          if (element[j]['start_time'] != '' && element[j]['end_time'] != '') {
            if (childScheduleDays.indexOf(i) == -1) {
              childScheduleDays.push(i)
            }
          }
        }
      }

      // console.log(parentScheduleDays)
      // console.log(childScheduleDays)

      const condition1 =
        childScheduleDays.filter((d) => !parentScheduleDays.includes(d))
          .length == 0

      const ddd = childScheduleDays.filter(
        (d) => !parentScheduleDays.includes(d)
      )
      this.ddd = ddd
      // console.log( 'ddd' )
      // console.log( ddd )

      ////End Condition 1
    },
    MergeUserScheduleSlots (UserData) {
      // console.log("UserData=")
      // console.log(UserData)

      //Change location format into nested format

      //let UserData = this.dataLocation.scheduledates

      //Nested format will be assigned to this variable
      const currentFormatSchedule = []

      for (const i in UserData.schedule.scheduledates) {
        const day = UserData.schedule.scheduledates[i].day

        if (typeof currentFormatSchedule[day] === 'undefined') {
          currentFormatSchedule[day] = []
        }

        currentFormatSchedule[day].push({
          start_time: UserData.schedule.scheduledates[i].start_time,
          end_time: UserData.schedule.scheduledates[i].end_time,
          ID: UserData.schedule.scheduledates[i].ID
        })
      }

      // console.log("currentFormatSchedule=")
      // console.log( currentFormatSchedule )

      // console.log("currentFormatScheduleEND=")

      ////Merge Current Format Slots
      const current_schedule_dates = []

      for (const day in currentFormatSchedule) {
        let current_schedule_seconds_slots = []
        current_schedule_dates[day] = []

        for (const j in currentFormatSchedule[day]) {
          if (
            currentFormatSchedule[day][j].start_time != '' &&
            currentFormatSchedule[day][j].end_time != ''
          ) {
            const currentSlotStartTimeArray = currentFormatSchedule[day][
              j
            ].start_time.split(':')
            const currentSlotEndTimeArray = currentFormatSchedule[day][
              j
            ].end_time.split(':')

            const currentSlotStartTimeSeconds = parseInt(
              currentSlotStartTimeArray[0] * 60 * 60 +
                currentSlotStartTimeArray[1] * 60
            ) //current start time seconds
            const currentSlotEndTimeSeconds = parseInt(
              currentSlotEndTimeArray[0] * 60 * 60 +
                currentSlotEndTimeArray[1] * 60
            ) //current end time seconds

            for (
              let s = currentSlotStartTimeSeconds;
              s <= currentSlotEndTimeSeconds;
              s += 60
            ) {
              current_schedule_seconds_slots.push(s)
            }
          }
        }

        if (current_schedule_seconds_slots.length > 0) {
          current_schedule_seconds_slots = [...new Set(current_schedule_seconds_slots)].sort(function (a, b) {
            return a - b
          })

          // console.log(day)
          // console.log(current_schedule_seconds_slots)

          let startTime = current_schedule_seconds_slots[0]
          const endTime = ''
          // console.log(day)
          //  console.log(current_schedule_seconds_slots[0])
          for (const k in current_schedule_seconds_slots) {
            // console.log( current_schedule_seconds_slots[k] )
            // console.log( typeof( current_schedule_seconds_slots[k+1] ) )

            if (
              typeof current_schedule_seconds_slots[parseInt(k) + 1] ===
                'undefined' ||
              current_schedule_seconds_slots[parseInt(k) + 1] -
                current_schedule_seconds_slots[k] !=
                60
            ) {
              if (startTime != current_schedule_seconds_slots[k]) {
                current_schedule_dates[day].push({
                  start_time: startTime,
                  end_time: current_schedule_seconds_slots[k]
                })

                if (
                  typeof current_schedule_seconds_slots[parseInt(k) + 1] !==
                  'undefined'
                ) {
                  startTime = current_schedule_seconds_slots[parseInt(k) + 1]
                }
              }
            }
          }

          //current_schedule_seconds_slots

          //console.log( current_schedule_seconds_slots )
        }
      }

      // console.log( 'current_schedule_dates' )
      // console.log( current_schedule_dates )

      // return

      ////End Merging Current Slots

      return current_schedule_dates
    },
    MergeCurrentSlot (scheduleDates) {
      ////Merge Current Slots
      const current_schedule_dates = []
      for (const day in scheduleDates) {
        const current_schedule_seconds_slots = []
        current_schedule_dates[day] = []

        for (const j in scheduleDates[day]) {
          if (
            scheduleDates[day][j].start_time != '' &&
            scheduleDates[day][j].end_time != ''
          ) {
            const currentSlotStartTimeArray = scheduleDates[day][
              j
            ].start_time.split(':')
            const currentSlotEndTimeArray = scheduleDates[day][j].end_time.split(
              ':'
            )

            const currentSlotStartTimeSeconds = parseInt(
              currentSlotStartTimeArray[0] * 60 * 60 +
                currentSlotStartTimeArray[1] * 60
            ) //current start time seconds
            const currentSlotEndTimeSeconds = parseInt(
              currentSlotEndTimeArray[0] * 60 * 60 +
                currentSlotEndTimeArray[1] * 60
            ) //current end time seconds

            // for( let s = currentSlotStartTimeSeconds; s<= currentSlotEndTimeSeconds; s += 60 )
            // {
            //   current_schedule_seconds_slots.push( s )
            // }
            current_schedule_dates[day].push({
              start_time: currentSlotStartTimeSeconds,
              end_time: currentSlotEndTimeSeconds
            })
          }
        }
      }
      this.current_schedule_dates = current_schedule_dates

      // console.log( 'current_schedule_dates' )
      // console.log( current_schedule_dates )

      // return

      ////End Merging Current Slots
    },
    SelectItem (id) {
      let status = false
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i] == id) {
          status = true
        }
      }
      if (status) {
        for (let i = 0; i < this.selected.length; i++) { 
          if (this.selected[i] === id) { 
            this.selected.splice(i, 1) 
          }
        }
      } else {
        this.selected.push(id)
      }
    },
    confStatus (status, id) {
      this.$apollo.mutate({
        mutation: UPDATE_STUDENT_STATUS,
        variables: {
          id,
          status
        }
      })
      this.acceptAlert()
    },
    setSelected (value) {
      this.custom_search_filter = value
    },
    cameraSelected (value) {
      this.custom_search_filter_camera = value
    },
    acceptAlert (status) {
      this.$vs.notify({
        color: 'success',
        title: 'Status Changed',
        position: 'top-right',
        text: 'Student Status Changed Successfully '
      })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    addNewCamUser (data) {
      this.camUserSidebarData = data
      this.toggleCamUserSidebar(true)
    },
    settingData (data) {
      this.sidebarSettingData = data
      this.toggleSettingSidebar(true)
    },
    StatusSuccess () {
      this.$vs.notify({
        title: 'Student',
        text: 'Student Deleted Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    confirmDeleteRecord (student) {
      this.DeletedItem = student
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${student.fname} ${student.lname}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    getCurrentPeriod () {
      const day = moment().format('dddd')
      const hr24 = moment(moment().format('LT'), ['h:mm A']).format('HH:mm')
      if (day == 'Monday') {
        this.currrent_schedule.dates.Monday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Tuesday') {
        this.currrent_schedule.dates.Tuesday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Wednesday') {
        this.currrent_schedule.dates.Wednesday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Thursday') {
        this.currrent_schedule.dates.Thursday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Friday') {
        this.currrent_schedule.dates.Friday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Saturady') {
        this.currrent_schedule.dates.Saturady.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Sunday') {
        this.currrent_schedule.dates.Sunday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
    },
    getUserSchedule (user) {
      const user_schedule = []
      if (user.schedule) {
        for (let j = 0; j < user.schedule.scheduledates.length; j++) {
          user_schedule.push(user.schedule.scheduledates[j])
        }
        this.dataUserSchedule.schedule.scheduledates = user_schedule
        this.CheckCondtion1(this.currrent_schedule.dates)
        this.MergeCurrentSlot(this.currrent_schedule.dates)
        const userMergedSlots = this.MergeUserScheduleSlots(
          this.dataUserSchedule
        )
        ////Condition 2: check each slot
        const condition2 = true
        let totalCurrentSlotSlots = 0
        let validCurrentSlots = 0
        for (const day in this.current_schedule_dates) {
          for (const j in this.current_schedule_dates[day]) {
            if (
              this.current_schedule_dates[day][j].start_time != '' &&
              this.current_schedule_dates[day][j].end_time != ''
            ) {
              totalCurrentSlotSlots++

              const currentSlotStartTimeSeconds = this.current_schedule_dates[
                day
              ][j].start_time
              const currentSlotEndTimeSeconds = this.current_schedule_dates[day][
                j
              ].end_time

              for (const i in userMergedSlots[day]) {
                if (
                  currentSlotStartTimeSeconds >=
                    userMergedSlots[day][i].start_time &&
                  currentSlotStartTimeSeconds <=
                    userMergedSlots[day][i].end_time
                ) {
                  validCurrentSlots++
                  break
                }
              }
            }
          }
        }
        // console.log(totalCurrentSlotSlots);
        // console.log(validCurrentSlots);
        // console.log(this.ddd)
        // condition2 = totalCurrentSlotSlots == validCurrentSlots

        //// End Condition 2
        if (
          totalCurrentSlotSlots == validCurrentSlots &&
          this.ddd.length == 0 &&
          totalCurrentSlotSlots + validCurrentSlots !== 0
        ) {
          //
        } else {
          const without_cam_student = []
          for (let i = 0; i < this.students.length; i++) {
            this.students[i].cameras = ''
            without_cam_student.push(this.students[i])
          }
          // this.students = without_cam_student;
        }
      }
    },
    conditionMethod (role, id) {
      if (role == 'user') {
        this.$apollo
          .mutate({
            mutation: GET_USER_STUDENTS,
            variables: {
              id
            }
          })
          .then((response) => {
            console.log(response)
            this.students = response.data.getUserStudents
            this.activeLoading = false
            this.$vs.loading.close()
            // this.getCurrentPeriod()
            // this.getUserSchedule(response.data.getUserStudents)
          })
      }
    },
    get () {
       let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.conditionMethod(userRole,userId)
    },
     VerifySms(){
     if(this.dataSmsCode){
      this.$apollo
        .mutate({
          mutation: MATCH_VERIFY_USER_SMS_CODE,
          variables: {
                phone:this.dataPhone,
                code:this.dataSmsCode
          }
        })
        .then(response => {
          if(response){
          if(response.data.matchVerifySmsCode.status==='Success'){
             this.userPhone=false
             this.phonePopup=false
             this.PhoneShow=true
             this.dataPhoneCode=null
             if(localStorage.getItem('userEmailPhone')){
              let old_userEmai = JSON.parse(localStorage.getItem('userEmailPhone'))
              localStorage.setItem('userEmailPhone',  JSON.stringify({'email':old_userEmai.email,'email_confirmed':old_userEmai.email_confirmed,'phone_verified':true}))
             }
             this.dataPhone=null


          }      
          this.$vs.notify({
                  title: 'Phone Verification',
                  text: response.data.matchVerifySmsCode.message,
                  color: response.data.matchVerifySmsCode.color,
                  position: 'top-right'
                })
          }  
        })
     }
    },
     acceptNumber () {
      const x = this.dataPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.dataPhone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    VerifyEmail(){
      if(this.dataEmailCode){
         this.$apollo
        .mutate({
          mutation: MATCH_VERIFY_USER_EMAIL_CODE,
          variables: {
                email:this.dataEmail,
                code:this.dataEmailCode
          }
        })
        .then(response => {
          if(response){
          if(response.data.matchVerifyEmailCode.status==='Success'){
             this.userEmail=false
             this.emailPopup=false
             this.EmailShow=true
             this.dataEmailCode=null
              if(localStorage.getItem('userEmailPhone')){
              let old_userPhone = JSON.parse(localStorage.getItem('userEmailPhone'))
              localStorage.setItem('userEmailPhone',  JSON.stringify({'email':this.dataEmail,'email_confirmed':true,'phone_verified':old_userPhone.phone_verified}))
             }
              this.dataEmail=null
          }      
          this.$vs.notify({
                  title: 'Email Verification',
                  text: response.data.matchVerifyEmailCode.message,
                  color: response.data.matchVerifyEmailCode.color,
                  position: 'top-right'
                })
          }  
        })
      }
    },
    SaveEmail(){
    if(this.dataEmail){
        this.$apollo
        .mutate({
          mutation: SEND_VERIFY_USER_EMAIL,
          variables: {
                email:this.dataEmail
          }
        })
        .then(response => {
          if(response.data.sendVerifyEmail.status==='Success'){
             this.EmailShow=false

          }
          else{
              this.$vs.notify({
                  title: 'Email Verification Failed',
                  text: 'Email Failed',
                  color: 'danger',
                  position: 'top-right'
                })
          }   
        })
    }
    },
    SavePhone(){
      if(this.dataPhone && this.dataPhone.length===14){
        this.$apollo
        .mutate({
          mutation: SEND_VERIFY_USER_SMS,
          variables: {
                phone:this.dataPhone
          }
        })
        .then(response => {
          if(response.data.sendVerifySms.status==='Success'){
             this.PhoneShow=false
          }
          else{
              this.$vs.notify({
                  title: 'Phone Verification Failed',
                  text: 'SMS Failed',
                  color: 'danger',
                  position: 'top-right'
                })
          }   
        })
      }
    },
    validEmail (value) {
      if (value.slice(0, 8) === 'temp-kv-'  &&  /^\d+$/.test(value.slice(9, 18))  &&  value.slice(value.length - 14) === 'kidsvision.com') {
        return false
      } else {
        return true
      }
    },
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()
    const result = Math.random().toString(36).substring(2, 15)
    this.encrptId = 'getrhmw7zcbabcdefghijklmnTrst1234wxyz07TmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TmnTrst123456Gwxyz'
    if(localStorage.getItem('userEmailPhone')){
     let userEmailPhone = JSON.parse(localStorage.getItem('userEmailPhone'))
      if(userEmailPhone.phone_verified){
          this.userPhone=false
      }
      else{
        this.userPhone=true
        this.oldPhone=userEmailPhone.phone
      }
      if(userEmailPhone.email_confirmed && this.validEmail(userEmailPhone.email) && userEmailPhone.email.length > 0){
           this.userEmail=false
      }
      else{
           this.userEmail=true
           this.oldEmail=userEmailPhone.email
      }
    }

  },
  mounted () {
    this.isMounted = true
  },
  beforeCreate () {
    this.activeLoading = true
    this.$vs.loading({
      type: 'sound'
    })
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  [data-letteruserstudent]:before {
    content: attr(data-letteruserstudent);
  }

  .letteruserstudent {
    display: inline-block;
    font-size: 50px;
    width: 80px;
    height: 80px;
    text-align: center;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: -10px;
    margin-bottom: 4px;
  }

  .user_add_btn {
    float: right;
    margin-top: -50px;
  }

  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px;
    }
  }

  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
    .product-img {
      height: 70px;
      border-radius: 50%;
    }
  }
}
</style>
